import CommonFormControl from "@/components/utils/CommonFormControl";
import { CommonStyledSelect, CommonStyledSelectMenuProps } from "@/components/utils/SelectStyles";
import { useCountries } from "@/contexts/CountriesContext";
import { CountryData } from "@/services/countries/CountriesService";
import { FormControlProps, FormLabel, SelectChangeEvent } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { Dispatch, SetStateAction, useEffect } from "react";
import { Control, Controller, ControllerRenderProps, FieldValues, UseFormRegister } from "react-hook-form";
import { useTranslation } from "react-i18next";

type CountrySelectProps = {
  register: UseFormRegister<FieldValues>;
  control: Control;
  selectedCountry: CountryData;
  setSelectedCountry: Dispatch<SetStateAction<CountryData>>;
  formControlProps?: FormControlProps;
  defaultValue?: string;
  title?: string;
  signup?: boolean;
  countries?: CountryData[];
  countryNames?: string[];
  hideTitle?: boolean;
  required?: boolean;
  name?: string;
};

function CountrySelect(props: CountrySelectProps) {
  const { t } = useTranslation("auth");

  const countriesContext = useCountries();
  const { countries, countryNames } = props.signup ? props : countriesContext;

  useEffect(() => {
    if (props.defaultValue) {
      props.setSelectedCountry(countries.find((c) => c.name === props.defaultValue));
    }
  }, [props.defaultValue]);

  function handleChange(event: SelectChangeEvent<unknown>, field: ControllerRenderProps<FieldValues>) {
    const selectedCountryName = event.target.value;
    const selectedCountryData = countries.find((country) => country.name === selectedCountryName);
    props.setSelectedCountry(selectedCountryData);
    field.onChange(event);
  }

  return (
    <CommonFormControl {...props.formControlProps}>
      {!props?.hideTitle && <FormLabel>{props.title ? props.title : t("countrySelect.defaultLabel")}</FormLabel>}
      <Controller
        name={props.name || "country"}
        control={props.control}
        rules={{ required: typeof props.required === "boolean" ? props.required : true }}
        defaultValue={props.defaultValue || ""}
        render={({ field, fieldState: { error } }) => (
          <CommonStyledSelect
            {...props.register(props.name || "country", { required: props.required })}
            value={field.value || props.defaultValue || ""}
            error={!!error}
            MenuProps={CommonStyledSelectMenuProps}
            onChange={(event) => handleChange(event, field)}
            required
          >
            {countryNames.map((c) => (
              <MenuItem key={c} value={c}>
                {c}
              </MenuItem>
            ))}
          </CommonStyledSelect>
        )}
      />
    </CommonFormControl>
  );
}

export default CountrySelect;
